import intl from 'react-intl-universal';
import {
    useState,
    useEffect,
    forwardRef,
    useRef,
    useImperativeHandle,
} from 'react';
import DynamicForm from '../..';
import { ProForm } from '@ant-design/pro-components';
import type {
    ProFormColumnsType,
    ProFormInstance,
} from '@ant-design/pro-components';
import type { ValueType } from '../index';
import { getCommonEnumInfo } from '@/api/common';
import { commonRules } from '@/commonConfig';

import style from '../index.less';

interface Props {
    form?: any;
    initialValues?: any;
    ref: ProFormInstance;
}

const H5Upload: React.FC<Props> = forwardRef(
    ({ initialValues, form: porpsForm }, ref: ProFormInstance) => {
        const [form] = ProForm.useForm();
        const formRef = useRef<ProFormInstance>(porpsForm || form);
        const [smsType, setSmsType] = useState<
            { label: string; value: number }[]
        >([]);

        useImperativeHandle(ref, () => {
            return formRef?.current || {};
        });

        useEffect(() => {
            getCommonEnumInfo('smsTypeEnum').then((res) => {
                if (res) {
                    setSmsType(
                        res.smsTypeEnum?.map((item) => ({
                            label: item.selectLabel,
                            value: item.selectValue,
                        })),
                    );
                }
            });
        }, []);

        useEffect(() => {
            formRef.current?.setFieldsValue?.(initialValues);
        }, [initialValues]);

        const columns: ProFormColumnsType<any, ValueType>[] = [
            {
                dataIndex: 'phone',
                valueType: 'text',
                title: intl.get('手机号'),
                formItemProps: {
                    rules: [
                        {
                            required: true,
                            message: intl.get('请输入用户手机号'),
                        },
                        ...commonRules.mobile,
                    ],
                },
                fieldProps: {
                    maxLength: commonRules.mobileLength,
                },
            },
            {
                dataIndex: 'smsType',
                valueType: 'select',
                title: intl.get('短信类型'),
                formItemProps: {
                    rules: [
                        {
                            required: true,
                            message: intl.get('请选择短信类型'),
                        },
                    ],
                },
                fieldProps: {
                    options: smsType,
                },
            },
            {
                title: intl.get('短信文案'),
                dataIndex: 'smsContent',
                valueType: 'textarea',
                readonly: true,
                initialValue: intl.get(
                    '【泡泡玛特】尊敬的顾客您好，您于【$】年【$】月【$】日咨询了【$】问题，请您上传附件加以佐证，对您的打扰深表歉意，上传地址：【链接】',
                ),
            },
        ];

        return (
            <div className={style.h5_upload_container}>
                <div className={style.h5_upload_tips}>
                    {intl.get(
                        '提交后将会把此短信发给顾客，请慎重填写相关信息，避免引起客诉！',
                    )}
                </div>
                <DynamicForm
                    form={form}
                    initialValues={initialValues}
                    ref={formRef}
                    columns={columns}
                    submitter={{
                        render: () => [],
                    }}
                ></DynamicForm>
            </div>
        );
    },
);

export default H5Upload;
